import { OnboardingViews } from '@features/onboarding'

const NewOnboardingPage = () => {
  return <OnboardingViews />
}

export default NewOnboardingPage
